import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import { CalendarPage } from './CalendarPage'

export function CalendarRoutes() {
  return (
    <Routes>
      <Route index element={<CalendarPage />} />
    </Routes>
  )
}
